import { BigCommerceStorefrontAPIBaseURL, platform } from '@/utils';
import { fetchCustomerJWT } from '@/utils/authToken';

/**
 * This function still presents due the merchant can logs in as a client and stencil channels trade the current customer jwt to recognize
 * which user is login on the channel
 */
export const getCurrentCustomerJWT = async (app_client_id: string) => {
  if (platform !== 'bigcommerce') {
    return undefined;
  }

  try {
    // Fetch JWT and store it in session storage
    return await fetchCustomerJWT(app_client_id);
  } catch (error) {
    // Only log errors that aren't 404 (since 404 are expected when not logged in)
    if (error instanceof Error && !error.message.includes('404')) {
      // Using b2bLogger instead of console.error
      // console.error('Error in getCurrentCustomerJWT:', error);
    }
    // Return an empty string if fetch fails
    return '';
  }
};

/**
 * For the less dependent on current customer jwt, this function it's called every time the customer logs in by using the login form
 * it makes the stencil channel recognize the user who log in the channel
 */
export const customerLoginAPI = (storefrontLoginToken: string) => {
  if (platform !== 'bigcommerce') {
    return;
  }

  // No longer storing token here to avoid duplication - using customer_jwt_token only
  // eslint-disable-next-line
  return fetch(`${BigCommerceStorefrontAPIBaseURL}/login/token/${storefrontLoginToken}`, {
    method: 'GET',
  })?.then();
};
